import logout from '$src/auth/sagas/logout'
import {Component} from '$src/handy'

export default class LogoutPage extends Component<{}, {}> {
  constructor(props: {}, context: any) {
    super(props, context)
  }
  UNSAFE_componentWillMount = () => {
    this.runSaga(logout).then(
      () => {
        console.log('logout successful')
      },
      (error: any) => {
        console.log(error)
      },
    )
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/auth/LogoutPage.tsx